<div>
  <div class="mb-6">
    <h1 class="!mt-0 !mb-2">Storage</h1>
    <p class="!mt-0 text-muted-color">
      Manage uploaded CAD files{{ isDrawingsEnabled ? " and drawings" : "" }}.
    </p>
  </div>

  @if (isDrawingsEnabled) {
    <p-tabs
      [value]="activeTab"
      (valueChange)="onTabChange($event)"
      class="mb-4"
    >
      <p-tablist>
        <p-tab value="cad">CAD files</p-tab>
        <p-tab value="drawing">Drawings</p-tab>
      </p-tablist>
    </p-tabs>
  }

  <!-- Each tab loads its own list, only while it is selected. -->
  @if (isDrawingsEnabled && activeTab === "drawing") {
    <app-drawing-storage-tab />
  } @else {
    <app-cad-storage-tab />
  }
</div>
